import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { InvitationFeedListComponent } from './invitation-feed-list.component';

@NgModule({
  declarations: [InvitationFeedListComponent],
  imports: [CommonModule],
  exports: [InvitationFeedListComponent]
})
export class InvitationFeedListModule {}
